import React, { useEffect } from "react";
import NumberInput from "globalComponents/NumberInput";

export default function DurationInput({ itemDuration, setItemDuration }) {
  useEffect(() => {
    console.log("itemDuration", itemDuration);
    if (itemDuration === null || itemDuration === undefined) {
      setItemDuration(60);
    }
  }, []);

  const durationUnits = itemDuration === "1" ? "minute" : "minutes";

  return (
    <div className="Duration-input" id="Duration-input">
      <NumberInput
        min="1"
        max="1440"
        defaultNum="60"
        className="duration-minutes"
        id="actualDuration-input"
        setValue={setItemDuration}
        value={itemDuration}
      />

      <span className="duration-units">{durationUnits}</span>
      <span className="duration-subscript subscript">Duration</span>
    </div>
  );
}
